import {defineMessages, useIntl} from 'react-intl'

import {AssignmentGroupLead} from '../leadTypes'

interface IAssignmentGroupBadgeProps {
  group?: AssignmentGroupLead | null
  /** Lo calcula el backend (`withinGroupExclusivity`): al vencer la ventana, la
   *  etiqueta desaparece. Acá no se recalcula el plazo para no desfasarse del
   *  backend si cambia LEAD_GROUP_EXCLUSIVITY_HOURS. */
  withinWindow?: boolean
  className?: string
}

const agM = defineMessages({
  tooltip: {
    id: 'leads.list.assignmentGroup.tooltip',
    defaultMessage:
      'Group this lead was just assigned to. The label disappears once the lead is no longer new.',
  },
})

/** Etiqueta con el grupo que recibió el lead, visible solo mientras el lead es nuevo. */
export const AssignmentGroupBadge: React.FC<IAssignmentGroupBadgeProps> = ({
  group,
  withinWindow,
  className,
}) => {
  const intl = useIntl()

  if (!group?.name || !withinWindow) return null

  return (
    <span
      className={`badge badge-light-info ${className ?? ''}`}
      title={intl.formatMessage(agM.tooltip)}
    >
      <i className='bi bi-people me-1' />
      {group.name}
    </span>
  )
}
